import React from "react";

interface ConditionalComponentWrapperProps {
  condition: boolean;
  children: React.ReactNode;
  className?: string
}

export const ConditionalComponentWrapper = ({children, condition, className} : ConditionalComponentWrapperProps) => {
  if(condition && className) return <div className={className}>{children}</div>;
  if(condition && !className) return <>{children}</>;

  return null;
}